function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscendPegman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.00001 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.9202,16H4.621l-.08361-1.221L4.45377,16H2.1546L2.071,10.6106l-.33442.8421a.64215.64215,0,0,1-.32228.3486.63528.63528,0,0,1-.472.0303l-.50164-.1684A.66206.66206,0,0,1,.076,11.3457a.66959.66959,0,0,1-.05338-.4825v-.0421c.12541-.3789,1.2959-4.7157,1.2959-4.7157a1.12136,1.12136,0,0,1,.34912-.57351A1.108,1.108,0,0,1,2.28,5.2633l.25082-.21052a2.92962,2.92962,0,0,1,.338-4.54211A2.88256,2.88256,0,0,1,4.49558.00021,2.83205,2.83205,0,0,1,6.5439.84231,2.95852,2.95852,0,0,1,7.38,2.90544a2.80893,2.80893,0,0,1-.9197,2.10523l.2927.21053a1.15767,1.15767,0,0,1,.6301.26567,1.17112,1.17112,0,0,1,.3731.57642S8.9685,10.779,8.9685,10.8211a.64806.64806,0,0,1-.0301.4754.64117.64117,0,0,1-.3461.3246l-.5435.1684a.677.677,0,0,1-.4658-.0432.68424.68424,0,0,1-.3284-.3357l-.2926-.7579Zm-1.50495-.8421H6.1259l.0836-6.65254.7943-.12631L8.007,11.0316l.1255-.0421c-.0837-.3368-.3345-1.34731-1.1705-4.58937A.26562.26562,0,0,0,6.8729,6.251a.26254.26254,0,0,0-.1618-.0614H6.4603l-.4598-.37894H5.20623l-.12541-.84209A2.01915,2.01915,0,0,0,6.1444,4.22813a2.04381,2.04381,0,0,0,.3995-1.23848,2.02033,2.02033,0,0,0-.55546-1.444A1.99152,1.99152,0,0,0,4.57918.92652h-.0836A2.03969,2.03969,0,0,0,3.152,1.42708a2.06755,2.06755,0,0,0,.75833,3.54149l-.12541.84209H2.99066l-.418.37894H2.32181a.30836.30836,0,0,0-.15523.06922.31171.31171,0,0,0-.09559.14131C1.23493,9.558.94231,10.6106.8169,10.9895l.12541.0421L1.98739,8.37905l.79426.12631.0836,6.65254H3.5341l.25082-3.5368a.64188.64188,0,0,1,.19988-.4174.63341.63341,0,0,1,.42717-.1721.62481.62481,0,0,1,.42924.1699.63341.63341,0,0,1,.19781.4196l.37623,3.5368Z",
    style: {
      fill: "#333",
      isolation: "isolate",
      opacity: 0.699999988079071
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.44724,5.68435l.45983-.379H6.1677l.5017.379",
    style: {
      fill: "#ce592c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53738,5.60013a2.63094,2.63094,0,0,0,1.12868-.12631A2.63084,2.63084,0,0,0,4.53738,5.3475a2.63087,2.63087,0,0,0-1.12869.12632A2.631,2.631,0,0,0,4.53738,5.60013Z",
    style: {
      fill: "#ce592c",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5923,10.9474,7.38,6.1896a.72.72,0,0,0-.2534-.36139.71172.71172,0,0,0-.4154-.14387H2.36362a.70394.70394,0,0,0-.40171.17119.7124.7124,0,0,0-.22533.37617L.44068,10.9895a.25769.25769,0,0,0,.12541.2948l.45983.1684a.25427.25427,0,0,0,.29262-.1263l1.12869-2.821.08361,7.07354H4.03575l.25082-3.9157a.19882.19882,0,0,1,.04856-.1437.1959.1959,0,0,1,.13538-.0668h.02508c.16721,0,.16721.0842.209.2105l.25082,3.9157H6.4603l.0836-7.07354L7.589,11.2843a.21821.21821,0,0,0,.1115.1221.216.216,0,0,0,.1644.0084l.5017-.1684a.2377.2377,0,0,0,.1711-.0994.24164.24164,0,0,0,.0379-.1954Z",
    style: {
      fill: "#fdbf2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.907,5.68434l1.63033,2.821,1.63033-2.821",
    style: {
      fill: "#cf572e",
      isolation: "isolate",
      opacity: 0.6000000238418579
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5374,5.38962A2.48424,2.48424,0,1,0,2.071,2.90544,2.47534,2.47534,0,0,0,4.5374,5.38962Z",
    style: {
      fill: "#fdbf2d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscendPegman);
export default __webpack_public_path__ + "static/media/Ascend-Pegman.ca6e268d27b0c59865d141837584c719.svg";
export { ForwardRef as ReactComponent };